'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import numbro from 'numbro';

// UI lib components
import { Text } from '@mantine/core';

// Types
import { LabelSizeProps } from './types';

// Local helpers & utils
import { getNumbroFormatOptions } from '@helpers/size';

// Style
import * as classes from './styles/index.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function LabelSize({ children, ...props }: LabelSizeProps) {
  /* ********************************** HOOKS ********************************* */

  /* ***************************** LOCAL VARIABLES **************************** */

  let value = children;
  if (typeof children === 'string' || typeof children === 'number') {
    const numbroFormatOptions = getNumbroFormatOptions(children);
    value = numbro(children).format(numbroFormatOptions as any);
  } else {
    value = '-';
  }

  /* ******************************** RENDERING ******************************* */

  return (
    <Text className={classes.labelSize} {...props}>
      {value}
    </Text>
  );
}

export default LabelSize;
